<template>
  <div id="puzzle-solution">
    <p>
      Every answer can be (loosely, but uniquely) associated to a member of the <span class="smallcaps"> Society of the Undistinguished</span>.
    </p>
    <ul>
      <li>Wegener created the theory of <span class="answer">CONTINENTAL</span> drift. </li>
      <li>van Gogh famously severed part of his left ear - while he was not <span class="answer">DEAF</span>, someone without any ears would be.</li>
      <li>Galilei's numerous astronomical and physical observations were <span class="answer">UNIVERSAL</span>. </li>
      <li>Kafka's Metamorphosis tells of Gregor Samsa, who transformed into a large insect, often pictured as a <span class="answer">BEETLE</span>.</li>
      <li>Many of Maier's photograph <span class="answer">NEGATIVE</span>s were never printed.</li>
    </ul>
    <p>
      After pairing up members with their favourite words, the race was on! Following the instructions led to four enigmatic words: 
      <span class="answer">BOTANICAL</span>,
      <span class="answer">DRUGSTORE</span>, 
      <span class="answer">PERIMETER</span>, and 
      <span class="answer">QUINTUPLE</span>.
    </p>

    <p>
      Finally, using the numbers obtained with Kafka's instructions, we obtain a 4x4 grid of letters. Transposing this grid and reading reveals the problem with the <span class="smallcaps">Enigmeta Machine</span>: it was <span class="answer">TURING INCOMPLETE</span>!
    </p>
      
    <img src="@/assets/img/soln-meta-1.jpg" alt="">

    <img src="@/assets/img/soln-meta-explosive.jpg" alt="">
    <img src="@/assets/img/soln-meta-free.jpg" alt="">
    <img src="@/assets/img/soln-meta-wordplay.jpg" alt="">
    <img src="@/assets/img/soln-meta-lorem.jpg" alt="">

    <img src="@/assets/img/soln-meta-kafka.jpg" alt="">
    <img src="@/assets/img/soln-meta-final.jpg" alt="">

    <vue-markdown>
*This series was centred around famous people who weren't recognized for their work until after their death.*

[***Gregor Mendel***](https://en.wikipedia.org/wiki/Gregor_Mendel) *, the "father of genetics", discovered many of the rules of heredity through cross-breeding pea plants, though his 1866 work was not recognized until nearly three decades later.*

[***Emily Dickinson***](https://en.wikipedia.org/wiki/Emily_Dickinson) *'s poetry was only published after her death, when her sister found her cache of nearly 1800 poems.*

[***Alfred Wegener***](https://en.wikipedia.org/wiki/Alfred_Wegener) *is remembered for his 1912 theory of continental drift, which was not accepted until the 1950s, two decades after his death.*

[***Vincent van Gogh***](https://en.wikipedia.org/wiki/Vincent_van_Gogh) *is arguably the most famous and influential painter of all time, although unsuccessful and deeply troubled throughout his short lifetime.*

[***Galileo Galilei***](https://en.wikipedia.org/wiki/Galileo_Galilei)*'s contributions are prominent throughout astronomy and physics today, including the four Galilean moons of Jupiter. His advocacy for the then-controversial heliocentrism led to his judgment of heresy and subsequent house arrest by the Roman Catholic Church.*

[***Franz Kafka***](https://en.wikipedia.org/wiki/Franz_Kafka)*'s surrealist realist writing (including his most famous novel, The Metamorphosis) only received public attention after his death, despite him burning most of his drafts.*

[***Vivian Maier***](https://en.wikipedia.org/wiki/Vivian_Maier)*'s street photography depicting the urban life in Chicago and New York weren't discovered until her photos went viral on Flickr just months after her death in 2009.*

[***Alan Turing***](https://en.wikipedia.org/wiki/Alan_Turing) *was well known for his work in computer science and cryptography during his lifetime, including helping crack the Enigma machine in World War II. Unfortunately, his legacy was marred by persecution for his sexuality, and his "crimes" were only pardoned in 2013.*
    </vue-markdown>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown-v2'

export default {
  components: {
    VueMarkdown
  }  
}
</script>

<style lang="scss" scoped>
  span.smallcaps {
    font-weight: bold;
    font-variant: small-caps;
    text-shadow: 1px 1px 1px rgb(196, 153, 10);
  }

  span.answer {
    font-weight: bold;
    color: rgb(19, 150, 67);
  }

</style>